import { env } from '@/env'

import { hasWindow } from './has-window'

const getBaseUrl = () => {
  if (hasWindow()) {
    return window.location.origin
  }
  // Server-side logic
  if (env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL) {
    return `https://${env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL}`
  }

  return 'http://localhost:3000'
}

export default getBaseUrl
